import { IIconBase } from '..'

const logoutIcon = ({
  color = '#DC3545',
  height = 40,
  width = 41,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 41 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.3333 12.6C15.8499 6.6 18.9333 4.15 25.6833 4.15H25.8999C33.3499 4.15 36.3333 7.13334 36.3333 14.5833V25.45C36.3333 32.9 33.3499 35.8833 25.8999 35.8833H25.6833C18.9833 35.8833 15.8999 33.4667 15.3499 27.5667'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.5001 20H6.53345'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.2501 14.4167L4.66675 20L10.2501 25.5833'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default logoutIcon
